import { Stack, Typography } from "@mui/material";
import type { MeasureDrillDownInfo } from "../../../../../../../../api/types/svTypes.ts";
import type { DrillDownPage } from "../../../../store/types/drillDownPageState.types";
import { getActiveLayer } from "../../../../store/utils/getActiveLayer.ts";
import SourceColumnLinks from "./SourceColumnLinks.tsx";
import { getLedgerTitle } from "./utils/getLedgerTitle";

interface Props {
  configuration: DrillDownPage;
  info: MeasureDrillDownInfo;
}

export default function LedgerTitle({ configuration, info }: Props) {
  const activeLayer = getActiveLayer(configuration);
  const ledger = getLedgerTitle(info);
  const sourceFields = info.valueTargetFields ?? [];
  const measureCaption =
    activeLayer.measure?.config.customLabel ||
    activeLayer.measure?.config.systemLabel ||
    activeLayer.measure?.meta.caption;

  return (
    <Stack sx={{ py: 1.5, gap: 0.3 }}>
      <Typography variant="h6">{ledger}</Typography>
      <Stack direction="row" sx={{ gap: 1, alignItems: "center" }}>
        {measureCaption && (
          <Typography variant="caption" color="textSecondary">
            {measureCaption} &#xa0;&bull;
          </Typography>
        )}
        {activeLayer.cell.formattedValue && (
          <Typography variant="caption" color="textSecondary">
            {activeLayer.cell.formattedValue}
          </Typography>
        )}
        {sourceFields.length > 0 && (
          <Typography variant="caption" color="textSecondary">
            <SourceColumnLinks fields={sourceFields} />
          </Typography>
        )}
      </Stack>
    </Stack>
  );
}
